export default [
    {
        path: 'transferencia-paciente',
        component: () => import(
            '@/views/transporte-paciente/transferencia/Index'
        ),
        redirect: 'transferencia-paciente/List',
        children: [
            {
                name: 'transporte-paciente-transferencia-paciente-list',
                path: 'list',
                component: () => import(
                    '@/views/transporte-paciente/transferencia/List'
                ),
            },
            {
                name: 'transporte-paciente-transferencia-paciente-create',
                path: 'create',
                props: true,
                component: () => import(
                    '@/views/transporte-paciente/transferencia/Form'
                ),
            },
        ],
    },
]